import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
const EntranceExamination = () => {
  useEffect(() => {
    document.title =
      "XI Class Enterance Test Result -  St Peters convent School Faridabad Haryana";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Admission </li>
          <li>Interaction and Entrance Examination Result </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>XI Class Enterance Test Result </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <h3> XI Class Enterance Test Result - 8th November 2025. </h3>

              <div className="table-responsive maintable">
                <table className="table">
                  <thead>
                    <tr>
                      <th>S.NO</th>
                      <th>CHILD'S NAME</th>
                      <th>REG. NO.</th>
                      <th>CLASS</th>
                      <th>SCHOOL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>PRATEEK SINGH MEHRA</td>
                      <td>XI 1081</td>
                      <td>X</td>
                      <td>SEC 16A</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>LAKSHITA PANT</td>
                      <td>XI 1110</td>
                      <td>X</td>
                      <td>SEC 16A</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>NAUMAN IMRAN</td>
                      <td>XI 1100</td>
                      <td>X</td>
                      <td>ST. ANTHONY'S</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>HARSH VARDHAN</td>
                      <td>XI 1108</td>
                      <td>X</td>
                      <td>SEC 16A</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>KARTIK YADAV</td>
                      <td>XI 1029</td>
                      <td>X-A</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>TANUJ</td>
                      <td>XI 1080</td>
                      <td>X-A</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>DEV KUMAR</td>
                      <td>XI 1094</td>
                      <td>X-A</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>DAKSHIT AHLAWAT</td>
                      <td>XI 1031</td>
                      <td>X-B</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>ANSHUL YADAV</td>
                      <td>XI 1032</td>
                      <td>X-B</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>PRIYANSHI</td>
                      <td>XI 1105</td>
                      <td>X-B</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>11</td>
                      <td>AARADHYA GIRI</td>
                      <td>XI 1021</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>12</td>
                      <td>DEV VIJ</td>
                      <td>XI 1014</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>13</td>
                      <td>ANSH KASHYAP</td>
                      <td>XI 1045</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>14</td>
                      <td>NITYA MALIK</td>
                      <td>XI 1053</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>15</td>
                      <td>AKSHITA SHARMA</td>
                      <td>XI 1071</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>16</td>
                      <td>AKSHAY SAINI</td>
                      <td>XI 1076</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>17</td>
                      <td>ADITYA KUMAR</td>
                      <td>XI 1077</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>18</td>
                      <td>ANANYA</td>
                      <td>XI 1096</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>19</td>
                      <td>GAGAN CHAHAR</td>
                      <td>XI 1098</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>20</td>
                      <td>PRIYANSHI</td>
                      <td>XI 1101</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>21</td>
                      <td>SNEHA</td>
                      <td>XI 1102</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>22</td>
                      <td>DHRUV GUPTA</td>
                      <td>XI 1103</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>23</td>
                      <td>SUHANI</td>
                      <td>XI 1104</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>24</td>
                      <td>VISHAL</td>
                      <td>XI 1106</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>25</td>
                      <td>RITESH</td>
                      <td>XI 1107</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>26</td>
                      <td>ARSHIA</td>
                      <td>XI 1109</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>27</td>
                      <td>ALISHA</td>
                      <td>XI 1111</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>28</td>
                      <td>TANYA</td>
                      <td>XI 1112</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>29</td>
                      <td>EKANSH ATTRI</td>
                      <td></td>
                      <td>X-A</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>30</td>
                      <td>SHIVAM</td>
                      <td>XI 1063</td>
                      <td>X-A</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>31</td>
                      <td>VIHAN ARORA</td>
                      <td>XI 1055</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>32</td>
                      <td>SAURABH</td>
                      <td>XI 1058</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>33</td>
                      <td>GURMAN SINGH</td>
                      <td>XI 1064</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>34</td>
                      <td>ANVAY RANA</td>
                      <td>XI 1066</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>35</td>
                      <td>YASH</td>
                      <td>XI 1067</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>36</td>
                      <td>GAURAV</td>
                      <td>XI 1069</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>37</td>
                      <td>DEEPAK</td>
                      <td>XI 1070</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>38</td>
                      <td>ARJUN</td>
                      <td>XI 1074</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>39</td>
                      <td>MAYANK</td>
                      <td>XI 1078</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>40</td>
                      <td>DIYA</td>
                      <td>XI 1082</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>41</td>
                      <td>SHREYA</td>
                      <td>XI 1083</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>42</td>
                      <td>ANJALI</td>
                      <td>XI 1084</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>43</td>
                      <td>JATIN</td>
                      <td>XI 1085</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>44</td>
                      <td>ANSHIKA</td>
                      <td>XI 1086</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>45</td>
                      <td>DIVYANSH</td>
                      <td>XI 1087</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>46</td>
                      <td>VIVEK</td>
                      <td>XI 1088</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>47</td>
                      <td>ANIKET</td>
                      <td>XI 1089</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>48</td>
                      <td>ANJALI</td>
                      <td>XI 1090</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>49</td>
                      <td>SHIVAM</td>
                      <td>XI 1091</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>50</td>
                      <td>RITIKA</td>
                      <td>XI 1092</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>51</td>
                      <td>BHAVYA</td>
                      <td>XI 1093</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>52</td>
                      <td>ACQUEENA</td>
                      <td>XI 1073</td>
                      <td>X</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>53</td>
                      <td>DAKSHIT SHARMA</td>
                      <td>XI 1079</td>
                      <td>X</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>54</td>
                      <td>DEVENDER SINGH</td>
                      <td>XI 1081</td>
                      <td>X</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>55</td>
                      <td>AARAV</td>
                      <td>XI 1082</td>
                      <td>X</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>56</td>
                      <td>AYUSHI</td>
                      <td>XI 1083</td>
                      <td>X</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>57</td>
                      <td>ANSHIKA</td>
                      <td>XI 1084</td>
                      <td>X</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>58</td>
                      <td>ADITYA</td>
                      <td>XI 1085</td>
                      <td>X</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>59</td>
                      <td>DAKSH</td>
                      <td>XI 1006</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>60</td>
                      <td>ARYAN NIRWANI</td>
                      <td>XI 1018</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>61</td>
                      <td>ARJUN SINGH</td>
                      <td>XI 1027</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>62</td>
                      <td>DEVANSH SINGH</td>
                      <td>XI 1007</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>63</td>
                      <td>DEVANSH PARASHAR</td>
                      <td>XI 1016</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>64</td>
                      <td>SHUBHAM CHOUDHARY</td>
                      <td>XI 1046</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>65</td>
                      <td>PRABHJOT SINGH</td>
                      <td>XI 1047</td>
                      <td>X-A</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>66</td>
                      <td>KARTIK NEGI</td>
                      <td>XI 1022</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>67</td>
                      <td>GEETANSHI YADAV</td>
                      <td>XI 1035</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>68</td>
                      <td>LAKSH GUPTA</td>
                      <td>XI 1075</td>
                      <td>X</td>
                      <td>SEC 16A</td>
                    </tr>
                    <tr>
                      <td>69</td>
                      <td>KUNSH SHARMA</td>
                      <td>XI 1012</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>70</td>
                      <td>SARABJOT SINGH</td>
                      <td>XI 1020</td>
                      <td>X-A</td>
                      <td>SEC-88, ST. PETER'Ss</td>
                    </tr>
                    <tr>
                      <td>71</td>
                      <td>SHANAYA SHARMA</td>
                      <td>XI 1038</td>
                      <td>X-B</td>
                      <td>SEC-88, ST. PETER'Ss</td>
                    </tr>
                    <tr>
                      <td>72</td>
                      <td>TARUSHI KAUSHIK</td>
                      <td>XI 1054</td>
                      <td>X-B</td>
                      <td>SEC-88, ST. PETER'Ss</td>
                    </tr>
                    <tr>
                      <td>73</td>
                      <td>VARYATA PARIHAR</td>
                      <td>XI 1072</td>
                      <td>X-B</td>
                      <td>SEC-88, ST. PETER'Ss</td>
                    </tr>
                    <tr>
                      <td>74</td>
                      <td>JIYA BHATT</td>
                      <td>XI 1090</td>
                      <td>X-B</td>
                      <td>SEC-88, ST. PETER'Ss</td>
                    </tr>
                    <tr>
                      <td>75</td>
                      <td>TANMEET SINGH</td>
                      <td>XI 1091</td>
                      <td>X</td>
                      <td>SEC 16A</td>
                    </tr>
                    <tr>
                      <td>76</td>
                      <td>HARSHIT GAUR</td>
                      <td>XI 1083</td>
                      <td>X-A</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>77</td>
                      <td>ABHINAV PRATAP SINGH</td>
                      <td>XI 1089</td>
                      <td>X-A</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>78</td>
                      <td>YAVYA REHLAN</td>
                      <td>XI 1076</td>
                      <td>X</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>79</td>
                      <td>MAULIK SHARMA</td>
                      <td>XI 1097</td>
                      <td>X</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>80</td>
                      <td>NAITIK SINGH</td>
                      <td>XI 1027</td>
                      <td>X-A</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>81</td>
                      <td>UJJWAL CHAKRABORTY</td>
                      <td>XI 1058</td>
                      <td>X-A</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>81</td>
                      <td>SHIVANG CHAHAR</td>
                      <td>XI 1060</td>
                      <td>X-A</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>82</td>
                      <td>ANKITA MORAL</td>
                      <td>XI 1088</td>
                      <td>X-A</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>83</td>
                      <td>HARSH KUMAR NARWAT</td>
                      <td>XI 1004</td>
                      <td>X-B</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>84</td>
                      <td>CHETANYA</td>
                      <td>XI 1017</td>
                      <td>X-B</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>85</td>
                      <td>ANSHIKA BHATT</td>
                      <td>XI 1026</td>
                      <td>X-B</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>87</td>
                      <td>BHAVY YADAV</td>
                      <td>XI 1059</td>
                      <td>X-B</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>88</td>
                      <td>MAHI SINGHAL</td>
                      <td>XI 1067</td>
                      <td>X-B</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>89</td>
                      <td>HARGUN MEHTA</td>
                      <td>XI 1066</td>
                      <td>X-B</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>90</td>
                      <td>ARCHANA RAI</td>
                      <td>XI 1065</td>
                      <td>X-B</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>91</td>
                      <td>ANVI SINGH CHAUHAN</td>
                      <td>XI 1062</td>
                      <td>X-B</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>92</td>
                      <td>MANSHIKA KUMARI</td>
                      <td>XI 1003</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>93</td>
                      <td>SANCHIT JAGLAN</td>
                      <td>XI 1010</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>94</td>
                      <td>KAVYANSH KIMOTHI</td>
                      <td>XI 1009</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>95</td>
                      <td>SHUBHAM KUMAR</td>
                      <td>XI 1030</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>96</td>
                      <td>RAJ ROSHAN</td>
                      <td>XI 1041</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>97</td>
                      <td>MANYAPREET KAUR</td>
                      <td>XI 1042</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>97</td>
                      <td>DEVAGYA</td>
                      <td>XI 1023</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>98</td>
                      <td>NAVDISHA SUKHIJA</td>
                      <td>XI 1024</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>99</td>
                      <td>DAIVIK DAGAR</td>
                      <td>XI 1028</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>100</td>
                      <td>BHAVYA PATHAK</td>
                      <td>XI 1034</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>101</td>
                      <td>GUNIKA SHAH</td>
                      <td>XI 1069</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>102</td>
                      <td>MEHAK ROHILLA</td>
                      <td>XI 1095</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>103</td>
                      <td>TANAY SHARMA</td>
                      <td>1013</td>
                      <td>X-A</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>104</td>
                      <td>ARCHNA</td>
                      <td>1044</td>
                      <td>X-B</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>105</td>
                      <td>MOHIT SEHRAWAT</td>
                      <td>1037</td>
                      <td>X-A</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>106</td>
                      <td>VANSHIKA YADAV</td>
                      <td>1052</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>107</td>
                      <td>DIKSHA</td>
                      <td>1056</td>
                      <td>X-B</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>108</td>
                      <td>KUNAL NARWAT</td>
                      <td>1084</td>
                      <td>X-A</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>109</td>
                      <td>YUVRAJ</td>
                      <td>1087</td>
                      <td>X-A</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>110</td>
                      <td>ANN MARIA JUSTIN</td>
                      <td>1078</td>
                      <td>X</td>
                      <td>SEC 16A</td>
                    </tr>
                    {/* NEW */}

                    <tr>
                      <td>111</td>
                      <td>VAISHNAVI BANSAL</td>
                      <td>1033</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>112</td>
                      <td>KHUSHI CHAUHAN</td>
                      <td>1040</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>113</td>
                      <td>AKHILA SHARMA</td>
                      <td>1063</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>114</td>
                      <td>SIDDID GOSAIN</td>
                      <td>1074</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>115</td>
                      <td>MAYANK BRAR</td>
                      <td>1104</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>116</td>
                      <td>SAKSHI SINGH</td>
                      <td>1102</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>117</td>
                      <td>BHAVYAA</td>
                      <td>1101</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                    <tr>
                      <td>118</td>
                      <td>ABHIGYA SHARMA</td>
                      <td>1107</td>
                      <td>X</td>
                      <td>ABM SCHOOL</td>
                    </tr>
                    <tr>
                      <td>119</td>
                      <td>SHIVI CHAUHAN</td>
                      <td>1108</td>
                      <td>X-C</td>
                      <td>SEC-88, ST. PETER'S</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default EntranceExamination;
